export default {
  labels: {
    radius: 'Straal',
  },
};
